export default "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\"><rect x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" rx=\"4\" /></svg>\n"